// extracted by mini-css-extract-plugin
module.exports = {"contentPageLayout":"ContentPageLayout__contentPageLayout__UqI5U"};